import { useCallback } from 'react'
import { ButtonBase, styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { useHistoryCustomBack } from 'weblite-router'
import { BottomDrawer } from '$common/bottom-drawer'
import { showChatListToolboxModal } from '$comp/modals/chat-list-toolbox'
import { NoneToVoidFunction } from '$hooks/types'
import { StaticWappsOnboarding } from '$comp/modals/static-wapps/onboarding'
import { Onboarding, onboarding } from '$logic/client-device'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { navigationStaticWapps } from './constants'

export function StaticWappsModal({ isOpen }: { isOpen?: boolean }) {
  const isDesktop = useIsDesktopSize()
  const handleBack = async () => {
    await closeCurrentModal()
    showChatListToolboxModal()
  }

  useHistoryCustomBack(() => {
    handleBack()
  }, [])

  const handleClick = useCallback(async (callBack: NoneToVoidFunction) => {
    await closeCurrentModal()
    callBack()
  }, [])

  // const showOnboarding = useMemo(() => {
  //   return onboarding.checkIfShouldView(Onboarding.STATIC_WAPPS) && isOpen
  // }, [isOpen])

  return (
    <BottomDrawer
      onClose={closeCurrentModal}
      isOpen={Boolean(isOpen)}
      alwaysIsDrawer
      paperProps={{
        sx: {
          ...(isDesktop && {
            margin: 'unset',
            right: 0,
            maxWidth: 360,
          }),
          overflow: 'visible',
        },
      }}
    >
      {/*<StaticWappsOnboarding*/}
      {/*  sx={{*/}
      {/*    position: 'absolute',*/}
      {/*    bottom: 'calc(100% + 12px)',*/}
      {/*    right: '24px',*/}
      {/*  }}*/}
      {/*  show={showOnboarding}*/}
      {/*/>*/}

      <Root>
        {navigationStaticWapps.map(({ name, icon, onClick, wId }) => (
          <ListItem
            key={wId}
            onClick={() => {
              handleClick(onClick)
            }}
          >
            {icon}
            <Typography variant="subtitle3">{name}</Typography>
          </ListItem>
        ))}
      </Root>
    </BottomDrawer>
  )
}

const Root = styled('div')`
  overflow: hidden;
  width: 100%;
  max-height: 100%;
  display: flex;
  border-radius: 15px;
  flex-direction: column;
`

const ListItem = styled(ButtonBase)`
  height: 56px;
  border-radius: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  justify-content: flex-start;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: ${({ theme }) => theme.palette.neutral100};
  }
  svg {
    color: ${({ theme }) => theme.palette.secondary700};
  }
`
